import {createEntityService} from "base/entity/service";
import {Service as DefaultService} from "app/common/service";
import {
    createNm12,
    createNm12List,
    nm12_api_adapter,
    nm12_list_api_adapter,
} from "app/nm12/Nm12";

const entityService = createEntityService(
    "/api/app/nm12",
    createNm12,
    createNm12List,
    nm12_api_adapter,
    nm12_list_api_adapter
);

export const Nm12Service = DefaultService(entityService);
